var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_radar",
    "data-name": "vuesax/bold/radar",
    transform: "translate(-300 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "radar",
    transform: "translate(300 316)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavida-log",
    transform: "translate(-105.564 -85.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(109.472 86.56)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M5.038-5.4v-4.38H6.881L9.514-5.4h4.117L9.729-11.7l3.925-5.744H9.538L6.809-12.991H5.038V-21.44H1.472V-5.4Z",
    transform: "translate(-1.472 21.44)",
    fill: "#6361ee"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogo);
export default __webpack_public_path__ + "static/media/k-logo.4311149bcf239befc18a7781bbd59a77.svg";
export { ForwardRef as ReactComponent };